import { Zap, Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";

const Footer = () => {
  const footerSections = [
    {
      title: "Ferramentas",
      links: [
        { name: "Prompts de IA", href: "/ferramentas" },
        { name: "Planilhas Inteligentes", href: "/ferramentas" }, 
        { name: "Modelos de Anúncios", href: "/ferramentas" },
        { name: "Automações de Vendas", href: "/ferramentas" }
      ]
    },
    {
      title: "Empresa",
      links: [
        { name: "Sobre Nós", href: "/sobre-nos" },
        { name: "Contato", href: "/contato" },
        { name: "Termos de Uso", href: "/termos-uso" },
        { name: "Política de Privacidade", href: "/politica-privacidade" }
      ]
    }
  ];

  return (
    <footer className="bg-foreground text-background">
      <div className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          {/* Logo and Description */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-gradient-primary rounded-lg flex items-center justify-center">
                <Zap className="w-5 h-5 text-white" />
              </div>
              <span className="text-xl font-bold">MarketPro Tools</span>
            </div>
            <p className="text-background/70 mb-6">
              A plataforma #1 para iniciantes em marketing digital. Transforme sua jornada com ferramentas simples e poderosas.
            </p>
            <div className="space-y-2 text-sm text-background/70">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4" />
                <span>contato@marketprotools.com.br</span>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4" />
                <span>+55 (11) 99913-6884</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4" />
                <span>São Paulo, Brasil</span>
              </div>
            </div>
          </div>

          {/* Footer Sections */}
          {footerSections.map((section, index) => (
            <div key={index}>
              <h3 className="font-semibold mb-4">{section.title}</h3>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link to={link.href} className="text-background/70 hover:text-background transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-background/70 text-sm">
            © 2024 MarketPro Tools. Todos os direitos reservados.
          </p>
          <div className="flex gap-6 text-sm text-background/70">
            <Link to="/termos-uso" className="hover:text-background transition-colors">Termos</Link>
            <Link to="/politica-privacidade" className="hover:text-background transition-colors">Privacidade</Link>
            <Link to="/contato" className="hover:text-background transition-colors">Contato</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;